function bm_callbacks_qr_success ( user_obj ) {
	if (typeof jelly !== 'undefined') {
		bmFireJelly( 'qr_success', user_obj, "widget-success" );
	}

	var tradeLink =  bm_callbacks_get_redirects_link("trade") ;
    bm_callbacks_apply_redirect(tradeLink) ;
}

function bm_callbacks_login_success ( user, redirectLink ) {
	// redirect
	if (redirectLink) {
		if (redirectLink == "refresh") {
			window.location.reload();
		} else if (redirectLink !== "stay"){
			window.location.href = redirectLink;
		}
	} else {
		var trade_url = bm_callbacks_get_redirects_link( 'trade' );
		if (window.location.hash) {
			trade_url = trade_url + window.location.hash;
		}
		bm_callbacks_apply_redirect(trade_url);
	}
}

// success event only for qds
function bm_callbacks_deposit_success ( result, lang ) {
	bm_callbacks_apply_redirect( bm_callbacks_get_redirects_link( 'trade' ) );
}

function bm_callbacks_qd_success ( result, lang ) {
	bm_callbacks_deposit_success( result, lang );
}